import * as React from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
const classNames = require('classnames');

import { IconChevronLeft, IconChevronRight } from '../icons';

interface Props {
	className?: string;
	TableComponent?: string | React.ComponentClass<any> | React.StatelessComponent<any>;
	columns?: Array<any>;
	data?: Array<any>;
	loading?: boolean;
	getTheadProps?: (...args: any[]) => {};
	getTheadThProps?: (...args: any[]) => {};
	getTbodyProps?: (...args: any[]) => {};
	getTrProps?: (...args: any[]) => {};
	getTdProps?: (...args: any[]) => {};
	minRows?: number;
	resizable?: boolean;
	sortable?: boolean;
	noDataText?: string;
	onPageChange?: (pageIndex: number) => void;
	page?: number;
	defaultPageSize?: number;
	setRef?: any;
	showPagination?: boolean;
}

class DataTable extends React.Component<Props, any> {
	onPageChange = (e: any, callback: () => void) => {
		// TODO: Find a better way to animate the page
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: 'smooth'
		});
		callback();
	}

	render() {
		const {
			className,
			TableComponent,
			columns,
			data,
			loading,
			getTheadProps = () => {
				return { className: 'thead' };
			},
			getTheadThProps = () => {
				return { className: 'th' };
			},
			getTbodyProps = () => {
				return { className: 'tbody' };
			},
			getTrProps = () => {
				return { className: 'tr' };
			},
			getTdProps = () => {
				return { className: 'td' };
			},
			minRows = 0,
			resizable = false,
			sortable = false,
			noDataText,
			onPageChange,
			page,
			defaultPageSize = 20,
			setRef,
			showPagination
		} = this.props;
		return (
			<ReactTable
				className={classNames('data-table', className)}
				TableComponent={TableComponent}
				columns={columns}
				data={data}
				loading={loading}
				getTheadProps={getTheadProps}
				getTheadThProps={getTheadThProps}
				getTbodyProps={getTbodyProps}
				getTrProps={getTrProps}
				getTdProps={getTdProps}
				minRows={minRows}
				resizable={resizable}
				sortable={sortable}
				PreviousComponent={p => (
					<button
						type="button"
						onClick={(e) => this.onPageChange(e, p.onClick)}
						disabled={p.disabled}
						className="btn btn-outline-secondary"
					>
						<IconChevronLeft />
					</button>
				)}
				NextComponent={p => (
					<button
						type="button"
						onClick={(e) => this.onPageChange(e, p.onClick)}
						disabled={p.disabled}
						className="btn btn-outline-secondary"
					>
						<IconChevronRight />
					</button>
				)}
				onPageChange={onPageChange}
				noDataText={noDataText}
				page={page}
				defaultPageSize={defaultPageSize}
				ref={setRef}
				showPagination={showPagination}
			/>
		);
	}
}

export default DataTable;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/common/DataTable.tsx